import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 max-w-4xl mx-auto">
        <div className="mb-10 md:mb-14 text-center">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-700 mb-4">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-question-line" />
            </span>
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 leading-snug">
            关于同类、平替与换一家
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, i) => {
            const open = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-lg border border-background-200/80 bg-background-100/50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : item.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-7 py-5 text-left cursor-pointer"
                >
                  <span className="flex items-start gap-3">
                    <span className="font-heading text-sm text-primary-500/80 mt-0.5">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug">
                      {item.q}
                    </span>
                  </span>
                  <span className="shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500">
                    <i className={open ? 'ri-subtract-line' : 'ri-add-line'} />
                  </span>
                </button>
                {open && (
                  <div className="px-5 md:px-7 pb-6 pl-5 md:pl-[3.4rem]">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}